import { Route } from '@angular/router';

import { ChangePinComponent } from './change-pin.component';

export const changePinRoute: Route = {
    path: 'cambiaPin',
    component: ChangePinComponent,
    data: {
        pageTitle: 'pagetitles.changepin'
    }
};
